import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getColumns } from "./config";
import AnalysisWidget from "../../../../../../Analysis/widget";
import DafTable from "../../../../../../../components/Table/newTable";

export default function AmpTasks({ data = [] }) {
  const { t } = useTranslation();
  const columns = getColumns({ t });
  const dataSource = useMemo(() =>
    data.map((d, i) => ({ ...d, key: i, id: i })), [data]);

  return (
    <AnalysisWidget className="with-border-header" title={t('Tasks')}>
      <div className='daf-table-wrapper no-pagination'>
        <DafTable
          doEmptyRows
          size="small"
          columns={columns}
          data={dataSource}
          scroll={{ y: 370 }}
          pagination={{ pageSize: 8 }}
          className="no-padding no-margin"
        />
      </div>
    </AnalysisWidget>
  );
}
